/***
 *
 *   PERIODIC REVIEWS
 *   Reviewer dashboard listing the account's open and in-progress periodic
 *   reviews (anniversary + ad-hoc) with the customer, rating, and due date
 *   (FR-012). Reads from GET /api/periodic-review/cases. Open a review to
 *   resolve it through one of the four actions.
 *
 **********/

import React, { Fragment, useEffect, useState } from "react";
import {
  Animate,
  Card,
  Message,
  Table,
  TitleRow,
  useAPI,
} from "components/lib";

const TYPE_LABELS = {
  anniversary: "Anniversary",
  ad_hoc: "Ad-hoc",
};

const STATUS_LABELS = {
  open: "Open",
  in_progress: "In progress",
};

function ratingLabel(rating) {
  if (!rating) return "-";
  return rating.charAt(0).toUpperCase() + rating.slice(1);
}

export function PeriodicReviewsView() {
  const cases = useAPI("/api/periodic-review/cases");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const list = Array.isArray(cases?.data) ? cases.data : [];

    setRows(
      list.map((c) => {
        const verification = c.verification || {};
        const name = [verification.first_name, verification.last_name]
          .filter(Boolean)
          .join(" ");
        const customer =
          name || verification.email || verification.name || "Unknown customer";

        return {
          id: c.id,
          customer,
          email: verification.email || "",
          type: TYPE_LABELS[c.event_type] || c.event_type || "-",
          rating: ratingLabel(c.rating),
          due_date: c.due_date || "",
          status: STATUS_LABELS[c.status] || c.status || "-",
        };
      })
    );
  }, [cases.data]);

  return (
    <Fragment>
      <Animate>
        <TitleRow title="Periodic Reviews" />

        <Message
          type="info"
          title="Customers due for periodic review"
          text="Customers whose review date has arrived, plus any ad-hoc reviews. Open a review to resolve it: full re-KYC, AML screening only, open an EDD case, or close the customer."
        />

        <Card>
          <Table
            search
            data={rows}
            loading={cases.loading}
            show={["customer", "email", "type", "rating", "due_date", "status"]}
            badge={{
              col: "status",
              color: "blue",
              condition: [
                { value: "Open", color: "orange" },
                { value: "In progress", color: "blue" },
              ],
            }}
            actions={{ view: { url: "/verification/periodic-review", col: "id" } }}
          />
        </Card>
      </Animate>
    </Fragment>
  );
}
